import React from 'react';
import { motion } from 'framer-motion';
import work from '../../assets/image/resume/resume-icon1.png';
import school from '../../assets/image/resume/resume-icon2.png';
import ItemExperience from "../../widgets/itemExperience";
import ItemEducation from "../../widgets/itemEducation";

const experiences = [
    {
        cargo: "Profesional independiente",
        tipo: "independiente",
        empresa: "",
        inicio: "Septiembre 2024",
        fin: "Actualidad",
        ubicacion: "Santa Cruz, Bolivia",
        descripcion: "Asesor en desarrollo de proyectos de software, implementación de sistemas, integración de aplicaciones y levantamiento de requerimientos para diseñar y crear soluciones tecnológicas basadas en las necesidades del cliente."
    },
    {
        cargo: "Full stack",
        tipo: "contrato temporal",
        empresa: "DIMA Ltda.",
        inicio: "Septiembre 2021",
        fin: "Junio 2024",
        ubicacion: "Santa Cruz, Bolivia",
        descripcion: "Responsable del sistema de comercio electrónico web Hipermaxi con frontend react.js y desarrollador de otros sistemas."
    },
    {
        cargo: "Full stack",
        tipo: "jornada completa",
        empresa: "Soluciones Inteligentes - Workcorp",
        inicio: "Enero 2020",
        fin: "Septiembre 2021",
        ubicacion: "Santa Cruz, Bolivia",
        descripcion: "Responsable del sistema nacional de servicios tributarios. Ingeniero de software del sistema de control de inventario."
    },
    {
        cargo: "Full stack",
        tipo: "jornada completa",
        empresa: "Desarrollamelo",
        inicio: "Septiembre 2019",
        fin: "Enero 2020",
        ubicacion: "Santa Cruz, Bolivia",
        descripcion: "Responsable del control del sistema web de logística de transporte."
    },
    {
        cargo: "Ingeniero de Software",
        tipo: "jornada completa",
        empresa: "Aztik - Soluciones Digitales",
        inicio: "Mayo 2019",
        fin: "Septiembre 2019",
        ubicacion: "Santa Cruz, Bolivia",
        descripcion: "Desarrollo de plataforma web educativa, implementación de reportes, control de asistencia, estadísticas y métricas de uso del sistema."
    },
    {
        cargo: "Ingeniero de Software",
        tipo: "jornada completa",
        empresa: "Supermercadomovil",
        inicio: "Enero 2019",
        fin: "Mayo 2019",
        ubicacion: "Santa Cruz, Bolivia",
        descripcion: "Desarrollador de sistemas ecommerce con PHP en Laravel para el BackEnd, Vue.js y Bootstrap para el FrontEnd."
    },
    {
        cargo: "Ingeniero de Software",
        tipo: "jornada completa",
        empresa: "Write Bolivia S.R.L",
        inicio: "Noviembre 2018",
        fin: "Abril 2019",
        ubicacion: "Santa Cruz, Bolivia",
        descripcion: "Desarrollo de software de sistema de recomendación."
    },
];

const educations = [
    {
        grado: "Ingeniería",
        formacion: "Ingeniería en Sistemas",
        escuela: "Universidad Autónoma Gabriel René Moreno",
        fin: "2019",
        ubicacion: "Santa Cruz, Bolivia",
    },
    {
        grado: "Bachillerato",
        formacion: "Secundaria",
        escuela: "Col. Nal. Guido Villa Gómez",
        fin: "2012",
        ubicacion: "Santa Cruz, Bolivia",
    },
];

const Experience = () => {
    return (
        <section id="experience" className="py-24 relative overflow-hidden">
            <div className="container mx-auto px-4 lg:px-8">
                {/* Header */}
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-16"
                >
                    <span className="text-accent-cyan font-medium tracking-widest text-sm uppercase mb-3 block">
                        Trayectoria
                    </span>
                    <h2 className="text-4xl md:text-5xl font-bold font-display text-white mb-6">
                        Resumen Profesional
                    </h2>
                    <div className="w-24 h-1 bg-gradient-to-r from-accent-blue via-accent-cyan to-accent-purple mx-auto rounded-full"></div>
                </motion.div>

                <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
                    {/* Experience section */}
                    <div className="flex-1">
                        <motion.div 
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            className="flex items-center gap-4 mb-10"
                        >
                            <div className="w-12 h-12 rounded-xl bg-accent-cyan/10 border border-accent-cyan/20 flex items-center justify-center">
                                <img src={work} alt="Experience" className="w-6 h-6 object-contain" />
                            </div>
                            <h3 className="text-3xl font-bold font-display text-white">Experiencia Laboral</h3>
                        </motion.div>

                        <div className="mt-8 ml-4 sm:ml-6 border-l border-white/5 relative">
                            {experiences.map((item, index) => (
                                <ItemExperience 
                                    key={index} 
                                    data={item}
                                    is={index === experiences.length - 1} 
                                    delay={index}
                                />
                            ))}
                        </div>
                    </div>

                    {/* Education section */}
                    <div className="flex-1 mt-16 lg:mt-0">
                        <motion.div 
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            className="flex items-center gap-4 mb-10"
                        >
                            <div className="w-12 h-12 rounded-xl bg-accent-purple/10 border border-accent-purple/20 flex items-center justify-center">
                                <img src={school} alt="Education" className="w-6 h-6 object-contain" />
                            </div>
                            <h3 className="text-3xl font-bold font-display text-white">Educación</h3>
                        </motion.div>

                        <div className="mt-8 ml-4 sm:ml-6 border-l border-white/5 relative">
                            {educations.map((item, index) => (
                                <ItemEducation 
                                    key={index} 
                                    data={item}
                                    is={index === educations.length - 1} 
                                    delay={index}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Background elements */}
            <div className="absolute top-1/4 left-0 w-96 h-96 bg-accent-purple/5 rounded-full blur-[100px] -z-10 transform -translate-x-1/2"></div>
            <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-accent-cyan/5 rounded-full blur-[100px] -z-10 transform translate-x-1/2"></div>
        </section>
    );
};

export default Experience;